import React, { useContext, useEffect, useRef, useState } from 'react';

import { BoxWrapper } from '../../../style';
import arrowIcon from "../../../images/arrow.png"
import { FormWrapper } from '../../../components/loan/style';
import Button from '../../../components/ui/Button';
import Alert from '../../../components/ui/Alert';

import { useLocation, useNavigate } from 'react-router-dom';
import { getStorage, goBack, isEmpty, setStorage } from '../../../Utils/common';

import { formValidation } from '../../../Utils/formValidation';
import PictureUpload from '../../../components/PictureUpload/PictureUpload';
import { ButtonWrapper } from '../../../components/ui/style';
import photoCapturIcon from "../../../images/photo-capture.svg";
import Webcam from 'react-webcam';
import TakeImage from '../../../components/TakeImage/TakeImage';
import ContextDashboard from '../../../Context/ContextDashboard';
import { saveProfile } from '../../../Utils/api';
import ProgressBar from "../../../components/ProgressBar/ProgressBar";

import { Camera } from "lucide-react";


function UploadPicture() {
  const [loading, setLoading] = useState(false);
  const [responce, setResponce] = useState({});

  const [openCamera, setOpenCamera] = useState(false)
  const [image, setImage] = useState("")
  const [base64, setBase64] = useState("")

  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const [showSteps, setShowSteps] = useState(-1);
  const [toggle, setToggle] = useState(true);
  const [progressBar, setProgressBar] = useState(getStorage("step_percent"));



  const { message, setMessage, logout, profileData, setps, handleEvent } = useContext(ContextDashboard);


  useEffect(() => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64 = reader.result;
      const data = base64.split(",");
      let img = data[data.length - 1];

      setBase64(img);
    };

    if (image) {
      if (typeof image === "string") {
        //const blob = new Blob([image]);
        //reader.readAsDataURL(blob);
        const data = image.split(",");
        let img = data[data.length - 1];
        setBase64(img);
      } else {
        reader.readAsDataURL(image);
      }

    }
  }, [image]);



  const submit = () => {


    if ((image === "") && (base64 === "")) {
      setMessage({ type: 'error', msg: "Please select image", place: "local" });
      return;
    } else {
      setMessage({})
    }
    let ext = "JPEG";
    if (typeof image === "object") {
      let extArr = image.name.split('.');
      ext = extArr[extArr.length - 1].toUpperCase();
    }



    const param = {
      profile_id: getStorage("cust_profile_id") || "",
      event_name: "selfie_upload",
      file: base64,
      file_ext: ext,
      // password: "N/A",
      // docs_id:"33"

    }



    setLoading(true);
    saveProfile(param).then(resp => {
      setLoading(false);

      if (resp?.data?.Status === 1) {
        setStorage("next_step", resp?.data?.Data?.next_step)
        setStorage("step_percent", resp?.data?.Data?.step_percentage)
        setStorage("selfie", resp?.data?.Data?.selfie_doc_url)
        setResponce(resp?.data);
        setMessage({ type: 'success', msg: resp?.data?.Message, place: "globle" });
        handleEvent(getStorage('next_step'));
        // if(!isEmpty(state?.action)){
        //   navigate("/my-dashboard/")
        // }else{
        //   navigate("/my-dashboard/profile-preview")
        // }

      } else if (resp?.data?.Status === 4) {
        logout();
      } else {
        setMessage({ type: 'error', msg: resp?.data?.Message, });
      }


    })

  }



  useEffect(() => {
    if (isEmpty(profileData)) return;
    if (!isEmpty(state?.action)) {



    }

  }, [profileData]);


  //   useEffect(() => {

  //     const params = {
  //         lead_id: getStorage("lead_id") || "",
  //         token: getStorage("token") || "",
  //         mobile: getStorage("mobile") || "",
  //     };

  //     getDashboardData(params).then(resp => {
  //         if (resp?.data?.Status === 1) {
  //             const dashboardData = resp?.data?.Steps?.data || {};
  //             if (dashboardData) {
  //                 setProgressBar(resp?.data?.Steps?.steps?.step_complete_percent);
  //             }
  //         } else if (resp?.data?.Status === 5) {
  //             logout();
  //         }
  //     });
  // }, [logout]);


  //   useEffect(() => {
  //     if (!isEmpty(setps)) {
  //         checkStep(setps);
  //     }
  // }, [setps]);

  // const checkStep = (data) => {
  //     const steps = (data?.step_stage - 1);
  //     if (data?.step_complete_percent === 100) {
  //         setToggle(false);
  //     }
  //     setShowSteps(steps);
  // };

  return (
    <>
      {progressBar !== 100 && progressBar !== undefined && (
        <ProgressBar value={`${progressBar}%`} />
      )}

      <br />
      {/* <BoxWrapper className="w100" >


        <div className="formmainBox flex gap-5  flex-col lg:flex-row  items-start rounded-lg">
          <div className="flex gap-1 items-center justify-center mb-5 pointer border border-gray-300 rounded-lg px-6 py-1 group hover:bg-gray-100 hover:border-gray-200 hover:bg-white transition-all duration-300" onClick={() => goBack(navigate, "/my-dashboard/")}>
            <img src={arrowIcon} alt="" className='w-4 mr-1 group-hover:-translate-x-1 transition-all duration-300' /> <span className='font-medium text-black'>Back</span>
          </div>

          <div className="right md:m-auto text-center right bg-white p-5 sm:p-10 text-center rounded-lg">
            <h2> {state?.action ? "Update Upload Your Picture *" : "Upload Your Picture *"}</h2>
            <p>Share you selfie and complete the registration.</p>

            <FormWrapper>
              <Alert setMessage={setMessage} message={message} />
              {openCamera && <TakeImage setImage={setImage} close={setOpenCamera} />}
              <div className="inputBox">


                {!openCamera && <>
                  <PictureUpload setImage={setImage} image={image} />
                </>}




              </div>
              {!openCamera && <>
                <h3 className='text-center my-4'>OR</h3>

                <ButtonWrapper className='selfyButton center m-auto' onClick={() => setOpenCamera(true)}>
                  <img src={photoCapturIcon} alt="" /> <span>Take a Selfie</span>
                </ButtonWrapper>
              </>}


              <div className="button m-auto">
                <Button className='bg-[#2D5F7A]' title={state?.action ? "Update" : "Continue"} onClick={submit} loading={loading} />
              </div>
            </FormWrapper>

          </div>
        </div>

      </BoxWrapper> */}
      <BoxWrapper className="w-full min-h-screen bg-gray-100 p-3 sm:p-5 md:p-8">

        <div className="flex flex-col gap-5">

          {/* Back Button */}
          <div
            className="inline-flex w-fit items-center gap-2 border border-gray-300 rounded-xl px-5 py-3 cursor-pointer bg-white hover:bg-gray-50 transition-all duration-300"
            onClick={() => goBack(navigate, "/my-dashboard/")}
          >
            <img
              src={arrowIcon}
              alt=""
              className="w-4 transition-transform duration-300 group-hover:-translate-x-1"
            />
            <span className="font-medium text-black">Back</span>
          </div>

          {/* Card */}
          <div className="w-full max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-5 sm:p-8 md:p-10">

            {/* Header */}
            <div className="text-center">

              <div className="flex justify-center mb-6">
                <div className="flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-2xl bg-[#EEF6FF] border border-blue-100 shadow-sm">
                  <Camera className="h-8 w-8 sm:h-10 sm:w-10 text-[#2D5F7A]" />
                </div>
              </div>

              <h2 className="text-2xl sm:text-3xl font-bold text-[#1D3557]">
                {state?.action
                  ? "Update Upload Your Picture *"
                  : "Upload Your Picture *"}
              </h2>

              <p className="mt-2 text-sm sm:text-base text-gray-500">
                Share you selfie and complete the registration.
              </p>

            </div>

            <FormWrapper className="mt-8  ">

              <Alert setMessage={setMessage} message={message} />

              {openCamera && (
                <TakeImage
                  setImage={setImage}
                  close={setOpenCamera}
                />
              )}

              {!openCamera && (
                <div className="mt-6 flex justify-center">
                  <PictureUpload
                    setImage={setImage}
                    image={image}
                  />
                </div>
              )}

              {!openCamera && (
                <>
                  <div className="flex items-center gap-4 my-8">
                    <div className="flex-1 border-t border-gray-300"></div>
                    <span className="text-gray-500 font-medium">OR</span>
                    <div className="flex-1 border-t border-gray-300"></div>
                  </div>

                  <ButtonWrapper
                    className="w-full sm:w-auto flex items-center justify-center gap-3 mx-auto px-6 py-3 rounded-xl border border-[#2D5F7A] text-[#2D5F7A] hover:bg-blue-50 transition"
                    onClick={() => setOpenCamera(true)}
                  >
                    <img
                      src={photoCapturIcon}
                      alt=""
                      className="w-5 h-5"
                    />
                    <span>Take a Selfie</span>
                  </ButtonWrapper>
                </>
              )}

              <div className="mt-8">
                <Button
                  className="w-full bg-[#2D5F7A]"
                  title={state?.action ? "Update" : "Continue"}
                  onClick={submit}
                  loading={loading}
                />
              </div>

            </FormWrapper>

          </div>

        </div>

      </BoxWrapper>
    </>
  )
}

export default UploadPicture;